module.exports = __webpack_public_path__ + "img/tellme.dd535f48.svg";